import { useEffect, useRef, useState } from "react";

export const Description = ({description, handleDescriptionUpdate}) => {    
    const [descriptionValue, setDescriptionValue] = useState(description); 
    const bottomRef = useRef(null);       

    const handleSubmitDescription = () => {
        handleDescriptionUpdate(descriptionValue);
    };
    
    const handleCancelDescription = () => {
        handleDescriptionUpdate(description);
    };

    useEffect(()=>{
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, []);

    return <>
        
            <div ref={bottomRef} className="details-input-container mb-3">
                <h6 className="fw-semibold">Edit the description below:</h6>
                <textarea
                value={descriptionValue}
                onChange={(e) => setDescriptionValue(e.target.value)}
                placeholder="Please enter additional details for this ticket..."
                className="form-control"
                rows="4"                
                />
                <div className="d-flex justify-content-end gap-2 mt-2">
                <button
                    onClick={() => handleSubmitDescription()}
                    className="btn btn-outline-secondary button-hover"
                    style={{ minWidth: "160px" }}                    
                >
                    {"Submit description"}
                </button>
                <button
                    onClick={() => handleCancelDescription()}
                    className="btn btn-outline-secondary button-hover"
                    style={{ minWidth: "100px" }}                   
                >
                    Cancel
                </button>
                </div>
            </div>
    
    </>
};